import React from "react";
import { FormattedMessage } from "react-intl";
import { verificarNotificacoes } from "../../../app/crud/notificacao.crud";
import { withRouter } from "react-router-dom";

class MenuItemText extends React.Component {
    constructor() {
        super();

        this.state = {
            notification: 0,
        };
    }

    componentDidMount() {
        this.checkNotifications();
        this.unlisten = this.props.history.listen(this.checkNotifications);
    }

    componentWillUnmount() {
        this.unlisten();
    }

    checkNotifications = () => {
        if (this.props.item.title === "Notificações") {
            verificarNotificacoes().then((res) => {
                this.setState({ notification: res.data });
            });
        }
    };

    render() {
        const { item, parentItem } = this.props;

        return (
            <>
                {this.state.notification > 0 && item.title === "Notificações" && <i className="fas fa-circle" style={{ color: "red", fontSize: "7px" }} />}

                {item.icon && <i className={`kt-menu__link-icon ${item.icon}`} />}

                {parentItem && parentItem.bullet === "dot" && (
                    <i className="kt-menu__link-bullet kt-menu__link-bullet--dot">
                        <span />
                    </i>
                )}

                {parentItem && parentItem.bullet === "line" && (
                    <i className="kt-menu__link-bullet kt-menu__link-bullet--line">
                        <span />
                    </i>
                )}

                <span className="kt-menu__link-text" style={{ whiteSpace: "nowrap" }}>
                    {!item.translate ? item.title : <FormattedMessage id={item.translate} defaultMessage={item.title} />}
                </span>

                {item.badge && (
                    <span className="kt-menu__link-badge">
                        <span className={`kt-badge ${item.badge.type}`}>{item.badge.value}</span>
                    </span>
                )}

                {item.submenu && <i className="kt-menu__ver-arrow la la-angle-right" />}
            </>
        );
    }
}

export default withRouter(MenuItemText);
